module.exports = __webpack_public_path__ + "img/2_52.08667630.png";